export enum WorkOrderType 
{
    Battery = 0,
    Brakes = 1,
    KeyFob = 2,
    TyreRepair = 3,
    TyreReplacement = 4,
    WiperBlades = 5
}